





import { Component } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import { GetCommunityAll } from "@/api/pdCommunity";

@Component
export default class SetCommunity extends AbpBase {
  data: any = [];
  columns = [
    {
      title: "社区名称",
      key: "name"
    }
  ];

  created() {
    this.getData();
  }

  async getData() {
    let res = await GetCommunityAll();
    this.data = res.objects;
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/pdReferral/pdScreening/setCommunity.vue